import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');
        let config = {
            slidesPerView: "auto",
            spaceBetween: 16,
            freeMode: {
                enabled: true,
                sticky: false,
                momentum: true,
            },
            centeredSlides: false,
            centeredSlidesBounds: false,
            centerInsufficientSlides: false,
            watchOverflow: true,
            observer: true,
            pagination: {
                el: this.element.querySelector(".js-swiper-pagination"),
                type: "bullets",
                clickable: true,
            },
        };
        this.initCarousel(config);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({FreeMode, Navigation, Pagination}) => {
                Swiper.use([FreeMode, Pagination, Navigation]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
}